import { metricsTrack } from '../../../utilities/analytics/index.js';
import { doMockApiCall } from '../../../utilities/backend-helpers/index.js';
import '../../../atoms/buttons/enums.js';
import { getLang } from '../../../utilities/dom-helpers/index.js';
import { apiResponseStub } from '../data/api-response-stub.js';

/* eslint-disable no-param-reassign */
let isFormStarted = false;
const isStepMandatory = (step) => step.isMandatory !== false;
const isStepReachable = (steps, idx) => !steps
    .slice(0, idx)
    .some(step => isStepMandatory(step) && !step.answered);
const setScrollTop = (scroll) => {
    document.body.scrollTop = scroll;
    document.documentElement.scrollTop = scroll;
};
const adjustFocus = (ctx, isEditStep, isLastStep = false) => {
    if (isEditStep ? true : !ctx.isLastStep) {
        setTimeout(() => {
            var _a, _b, _c;
            const expandedItem = ctx.renderRoot.querySelector('ops-step[isexpanded]');
            (_b = (_a = expandedItem === null || expandedItem === void 0 ? void 0 : expandedItem.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('button')) === null || _b === void 0 ? void 0 : _b.scrollIntoView();
            (_c = expandedItem === null || expandedItem === void 0 ? void 0 : expandedItem.querySelector('input.option')) === null || _c === void 0 ? void 0 : _c.focus();
        }, 0);
    }
    if (isLastStep) {
        const getResultsBtn = ctx.shadowRoot.querySelector('generic-button');
        setTimeout(() => {
            getResultsBtn === null || getResultsBtn === void 0 ? void 0 : getResultsBtn.scrollIntoView({
                block: 'end',
                inline: 'nearest',
                behavior: 'smooth',
            });
        }, 0);
    }
};
const setActiveStep = (stepsArr, ctx, idx, e) => {
    const target = e.target;
    if (target.tagName === 'OPS-STEP') {
        if (!stepsArr[idx].answered && !isStepReachable(stepsArr, idx))
            return;
        stepsArr.forEach((s, i) => {
            ctx.currentStep = idx;
            s.active = idx === i;
        });
        ctx.isLastStep = ctx.currentStep === stepsArr.length - 1;
        ctx.canGetResults =
            ctx.isLastStep &&
                (!isStepMandatory(stepsArr[idx]) || stepsArr[idx].answered);
        adjustFocus(ctx, true);
    }
};
const metricsEvents = (s, ctx, optionIndex, isUnchecked) => {
    if (!s.options[optionIndex].isMultipleChoice) {
        metricsTrack('cevt_form_step_interaction', {
            dlv_form_name: ctx.formName,
            dlv_form_id: ctx.formId,
            dlv_form_type: ctx.formName,
            dlv_step_number: ctx.currentStep + 1,
            dlv_step_name: s.type,
        });
    }
    if (!isUnchecked) {
        metricsTrack('cevt_form_select_interaction', {
            dlv_form_name: ctx.formName,
            dlv_form_id: ctx.formId,
            dlv_form_type: ctx.formName,
            dlv_form_question_name: s.question,
            dlv_form_selection_name: s.selectedOptions
                ? s.selectedOptions[s.selectedOptions.length - 1]
                : '',
        });
    }
};
const applyStepSelection = (step, optionIndex, target, ctx) => {
    const selectedOption = step.options[optionIndex];
    const isMultiSelect = selectedOption.isMultipleChoice;
    if (isMultiSelect) {
        selectedOption.selected = target.checked;
    }
    else {
        step.options.forEach(option => {
            option.selected = false;
        });
        selectedOption.selected = true;
    }
    target.checked = selectedOption.selected;
    step.selectedOptions = step.options
        .filter(option => option.selected)
        .map(option => option.shortName);
    const isUnchecked = isMultiSelect && !selectedOption.selected;
    step.answered = step.selectedOptions.length > 0;
    metricsEvents(step, ctx, optionIndex, isUnchecked);
};
const setSelectedOption = (stepsArr, ctx, optionIndex, e) => {
    var _a, _b;
    const target = (_a = e.currentTarget
        .closest('.option-container')) === null || _a === void 0 ? void 0 : _a.querySelector('input');
    if (!target)
        return;
    if (!isFormStarted) {
        metricsTrack('cevt_form_start', {
            dlv_event_action: 'start',
            dlv_event_category: 'form',
            dlv_form_type: ctx.formName,
            dlv_form_name: ctx.formName,
            dlv_form_id: ctx.formId,
        });
        isFormStarted = true;
    }
    const currentStepData = stepsArr[ctx.currentStep];
    if (!currentStepData || !currentStepData.active)
        return;
    applyStepSelection(currentStepData, optionIndex, target, ctx);
    ctx.isLastStep = ctx.currentStep === stepsArr.length - 1;
    const canProceedCurrentStep = currentStepData.answered || !isStepMandatory(currentStepData);
    const isMultiSelectStep = (_b = currentStepData.isMultipleChoice) !== null && _b !== void 0 ? _b : currentStepData.options.some(option => option.isMultipleChoice);
    const shouldAutoAdvance = !ctx.isLastStep && !isMultiSelectStep && canProceedCurrentStep;
    if (shouldAutoAdvance) {
        ctx.currentStep += 1;
    }
    stepsArr.forEach((step, idx) => {
        step.active = idx === ctx.currentStep;
    });
    ctx.isLastStep = ctx.currentStep === stepsArr.length - 1;
    const currentStep = stepsArr[ctx.currentStep];
    ctx.canGetResults =
        ctx.isLastStep && (currentStep.answered || !isStepMandatory(currentStep));
    ctx.requestUpdate();
    if (!ctx.isLastStep) {
        adjustFocus(ctx);
        return;
    }
    adjustFocus(ctx, false, true);
};
const triggerOptionInput = (e) => {
    var _a;
    e.preventDefault();
    const target = (_a = e.currentTarget
        .closest('.option-container')) === null || _a === void 0 ? void 0 : _a.querySelector('input');
    if (!target)
        return;
    if (target.type === 'checkbox') {
        target.checked = !target.checked;
    }
    else {
        target.checked = true;
    }
    target.dispatchEvent(new Event('change', { bubbles: true }));
};
const getQuestionnaireResults = (ctx) => {
    const stepsResults = JSON.parse(JSON.stringify(ctx.steps.filter(s => s.answered)));
    const questionnaireResults = [];
    for (const stepsResult of stepsResults) {
        const questionnaireResult = {
            type: '',
            options: [],
            apiReadyName: '',
        };
        stepsResult.options = stepsResult.options.filter((o) => o.selected);
        questionnaireResult.type = stepsResult.type;
        questionnaireResult.options = stepsResult.options;
        stepsResult.options.forEach((o) => {
            questionnaireResult.apiReadyName = [
                ...questionnaireResult.apiReadyName,
                o.value,
            ];
        });
        questionnaireResults.push(questionnaireResult);
    }
    return questionnaireResults;
};
const getCategories = (questionnaireResults) => {
    var _a;
    const namesArr = [];
    for (const questionnaireResult of questionnaireResults) {
        const apiReadyNames = ((_a = questionnaireResult.apiReadyName) !== null && _a !== void 0 ? _a : []);
        namesArr.push(...apiReadyNames.filter((name) => typeof name === 'string' && name.trim().length > 0));
    }
    return namesArr;
};
const setFormFields = (data) => {
    const productNames = data.products.map(p => p.title).join(',');
    const productIccCodes = data.products.map(p => p.iccCode).join(',');
    const updateProductDetailsEvent = new CustomEvent('update-product-details', {
        detail: {
            productNameList: productNames,
            productIccCodeList: productIccCodes,
        },
    });
    window.dispatchEvent(updateProductDetailsEvent);
};
const getOptionNamesByStep = (steps) => steps.map(step => {
    var _a;
    return ({
        type: step.type,
        optionName: ((_a = step.selectedOptions) !== null && _a !== void 0 ? _a : []).join(', '),
    });
});
const formSubmit = (e, ctx, endpoint) => {
    var _a;
    e.preventDefault();
    const results = getQuestionnaireResults(ctx);
    const productCategories = getCategories(results);
    ctx.selectedOptions = getOptionNamesByStep(ctx.steps);
    ctx.formData = {
        categories: productCategories,
        language: (_a = getLang()) !== null && _a !== void 0 ? _a : 'en-us',
    };
    if (!productCategories.length) {
        ctx.hasResults = true;
        ctx.apiResponseData = { products: [] };
        setScrollTop(0);
        return;
    }
    if (ctx.devEnvironment) {
        doMockApiCall(apiResponseStub, false)
            .then(r => {
            ctx.hasResults = true;
            ctx.apiResponseData = r;
            setScrollTop(0);
        })
            .catch(err => console.warn(err));
    }
    else {
        fetch(endpoint, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(ctx.formData),
        })
            .then(res => res.json())
            .then(data => {
            var _a, _b, _c, _d, _e, _f, _g;
            const firstProductUrl = (_b = (_a = data === null || data === void 0 ? void 0 : data.products) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.url;
            if (((_c = data === null || data === void 0 ? void 0 : data.products) === null || _c === void 0 ? void 0 : _c.length) === 1 && firstProductUrl) {
                window.location.assign(firstProductUrl);
                return;
            }
            ctx.hasResults = true;
            ctx.apiResponseData = data;
            setFormFields(data);
            setScrollTop(0);
            metricsTrack('cevt_form_submit', {
                dlv_event_category: 'form',
                dlv_event_action: 'submit',
                dlv_form_name: ctx.formName,
                dlv_form_type: ctx.formName,
                dlv_form_id: ctx.formId,
                dlv_button_text: (_e = (_d = e.target.shadowRoot) === null || _d === void 0 ? void 0 : _d.querySelector('.primary-button')) === null || _e === void 0 ? void 0 : _e.innerText,
            });
            if ((_f = ctx.steps.find(s => s.active)) === null || _f === void 0 ? void 0 : _f.isMultipleChoice) {
                metricsTrack('cevt_form_step_interaction', {
                    dlv_form_name: ctx.formName,
                    dlv_form_id: ctx.formId,
                    dlv_form_type: ctx.formName,
                    dlv_step_number: ctx.currentStep + 1,
                    dlv_step_name: (_g = ctx.steps.find(s => s.active)) === null || _g === void 0 ? void 0 : _g.type,
                });
            }
        })
            .catch(err => console.warn(err));
    }
};
const resetStepsData = (ctx) => {
    for (let i = 0; i < ctx.steps.length; i += 1) {
        ctx.steps[i].active = i === 0;
        ctx.steps[i].answered = false;
        ctx.steps[i].selectedOptions = null;
        for (const option of ctx.steps[i].options) {
            option.selected = false;
        }
    }
};
const handleQuestionnareReset = (ctx) => {
    resetStepsData(ctx);
    ctx.currentStep = 0;
    ctx.canGetResults = !ctx.canGetResults;
    ctx.hasResults = !ctx.hasResults;
    setScrollTop(0);
};

export { formSubmit, getQuestionnaireResults, handleQuestionnareReset, setActiveStep, setFormFields, setScrollTop, setSelectedOption, triggerOptionInput };
